import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { useEffect, useState } from "react"
import apis from "../../api"
import {  getUserSession,  } from "../../Utils/Common"
import {  settingDataLoader } from "../../Component/DataLoader"


const ClassroomSelector = (props) => {
    const { defaultValue,onChange,classrooms,name,label } = props
    const [_classrooms,setClassrooms] = useState(classrooms)
    const [error,setError] = useState()
    getUserSession(apis)
    useEffect(()=>{
        if(!_classrooms) {
            settingDataLoader('classroom',1,apis,(data)=>{setClassrooms(data)},setError)
        }
    },[])
    return <FormControl fullWidth sx={props.sx}>
        <InputLabel id="demo-simple-select-autowidth-label">{label} {error && <font style={{color:'red'}}>{error}</font>}</InputLabel>
        <Select labelId="demo-simple-select-autowidth-label"
            id={name}
            onChange={(e) => { 
                let id = e.target.value; 
                let choice = false
                if(id>0) {
                    for(let i=0;i<_classrooms.length;i++) {
                        if(id == _classrooms[i].id) {
                            onChange && onChange(name,_classrooms[i])
                            choice = true
                            break
                        }
                    }
                }
                if(!choice) {
                    onChange && onChange(name,{id:0})
                }
            }}
            defaultValue={defaultValue}
            label={label}>
            <MenuItem value={0}>Nothing</MenuItem>
            {_classrooms && _classrooms.map((p, idx) => {                       
                return p.status == 1 && <MenuItem key={idx} value={p.id}>{p.name}</MenuItem>
            })}
        </Select>
    </FormControl>
}
export default ClassroomSelector